import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'src/App/Dashboards/Market/Components';
import { MuiThemeProvider } from 'src/core/MuiThemeProvider';
import { StoreProvider } from 'src/core/StoreProvier';
import { Routes } from 'src/App/Routes';
import { useCacheBuster } from 'src/core/CacheBuster';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ErrorLog from './core/ErrorLog';

const App = () => {
  // const { loading, isLatestVersion, refreshCacheAndReload } = useCacheBuster();

  const isLocalHost = window.location.hostname === 'localhost';

  // TODO: This was triggering a cache refresh and stuck on infinite loop. Need to fix this.
  // useEffect(() => {
  //   if (!loading && !isLatestVersion) {
  //     refreshCacheAndReload();
  //   }
  // }, [loading, isLatestVersion]);

  return (
    <GoogleOAuthProvider clientId="1086841274014-4f4pslr93cq86mrad8gba18b75v7i2de.apps.googleusercontent.com">
      <BrowserRouter>
        <StoreProvider>
          <MuiThemeProvider>
            <ErrorBoundary>
              <ErrorLog isTest={isLocalHost}>
                <Routes />
              </ErrorLog>
            </ErrorBoundary>
          </MuiThemeProvider>
        </StoreProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;
